import React, { useEffect, useState, useContext } from "react"
import { TimelineContext } from "../../helpers/Context";
import { isMobile } from "react-device-detect";

const NSSelector = ({ options, contexto, onCallBack, oneSelection, criticalItems }) => {

    const contextTimeline = useContext(TimelineContext);

    const [current, setCurrent] = useState(null)
    const checkBoxType = oneSelection ? "radio" : "checkbox"

    const handlerOnClick = (item, value) => {
        console.log("Hemos seleccionado: " +  item)
        setCurrent(item)
        if (onCallBack) {
            onCallBack(item)
        }
    }

    useEffect(() => {

    }, [])

    return (
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-2">
            {options.map(
                (item, index) => {
                    const isCurrent = current === item
                    const isCritical = criticalItems?.includes(index)
                    return (
                        <div htmlfor={`option-${index}`}
                            style={{
                                background:
                                    isCurrent ? isCritical ? "#F9839A" : "#2AAC9C" :
                                        isCritical ? "#FEEFF2" : "#EAF7F5",
                                color: isCurrent ? "white" : "black"
                            }}
                            className=" flex gap-4 py-3 w-full rounded p-3 min-h-[60px] text-lg items-center cursor-pointer"
                            onClick={() => handlerOnClick(item, index)}
                            key={`key-option-${index}`}
                        >
                            <input
                                type={checkBoxType}
                                style={{
                                    accentColor: isCurrent ? "black" : "",
                                }}
                                className="h-[30px] w-[30px]  text-[22px] checked:bg-[black]"
                                id={`option-${index}`}
                                value={item}
                                checked={isCurrent}
                            />
                            <label for={`option-${index}`}
                                className="w-full cursor-pointer text-[18px]"
                            >
                                {item}
                            </label>
                        </div>
                    )
                }
            )
            }
        </div>
    )
}

export default NSSelector